import type { ReactElement } from 'react';
import { useMatch } from 'react-router';
import { useSiteSettingsQuery } from '@/entities/site-setting';
import { STORE_CUSTOMIZE_ROUTE_PATTERN } from '@/shared/config';

/**
 * 카카오톡 상담 버튼(운영 설정 설계 K1·K3·K5) — 모든 화면 오른쪽 아래에 떠서 채널 1:1 채팅을 새 탭으로 연다.
 * 카카오톡 채널 플로팅 버튼처럼 노란 원 안에 카카오톡 말풍선 로고만 보이고, 이름은 화면 낭독용 글자·title 로 둔다.
 * 운영 설정에 채널 주소가 없거나 아직 못 읽었으면 그리지 않고, 화면을 가득 채우는 커스터마이징 에디터와 인쇄에서도 숨긴다.
 * 비회원 견적 연결 안내(z-50)가 뜨면 그 아래에 깔린다.
 */
export const KakaoChatButton = (): ReactElement | null => {
  const settingsQuery = useSiteSettingsQuery();
  const isEditor = useMatch(STORE_CUSTOMIZE_ROUTE_PATTERN) !== null;
  const chatUrl = settingsQuery.data?.kakaoChannelChatUrl ?? null;
  if (isEditor || chatUrl === null) return null;

  return (
    <a
      href={chatUrl}
      target="_blank"
      rel="noopener noreferrer"
      title="카카오톡 상담"
      className="fixed right-4 bottom-4 z-40 inline-flex size-14 items-center justify-center rounded-full bg-[#FEE500] shadow-lg transition hover:brightness-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:right-8 sm:bottom-8 print:hidden"
    >
      <svg aria-hidden="true" viewBox="0 0 24 24" className="size-7" fill="#191919">
        <path d="M12 3C6.48 3 2 6.54 2 10.9c0 2.82 1.87 5.3 4.69 6.7l-.95 3.48c-.08.31.27.56.54.38l4.15-2.75c.51.07 1.04.1 1.57.1 5.52 0 10-3.54 10-7.91S17.52 3 12 3Z" />
      </svg>
      <span className="sr-only">카카오톡 상담</span>
    </a>
  );
};
